

export function Prod(){
 return (<section className="prodective">
  <div className="container">
    <div className="content">
          <div className="img-prod">
            <img src='images/illustration-stay-productive.png' alt="" />
          </div>
          <div className="text-prod">
            <h1>Stay productive, wherever you are </h1>
            <p>
            Never let location be an issue when accessing your files. Fylo has you covered for all of your file 
            storage needs.</p>
            <p>
            Securely share files and folders with friends, family and colleagues for live collaboration. No email 
            attachments required. </p>
        <span>See how Fylo works <img src="images/icon-arrow.svg" alt=""/></span>   
          </div>
    </div>
  </div>
 </section>
)
}
export default Prod;